import React from 'react'
import { Constants } from '../../Constants/Constants'

export default function FeedBackIframe(props) {
  
  return (
    <div onClick={()=>{
      props.closeFeedBackIframe({triggerScreen:"A80"})
    }} className='feedbackIframeContainer' style={{height:Constants.chatHeight,width:'100%'}}>
      <div className='feedbackUrlCloseIcon'> X </div>
 <iframe
 height={"95%"}
 width={"95%"}
 frameBorder={"1px solid grey"}
 style={{background: "white",
border:"1px solid #E10092"}}
 
    src={props.feedbackUrl}
    ></iframe>
    </div>
   
  )
}
